module.exports = __webpack_public_path__ + "img/icon_2.f7f92254.png";